/*----TO INCLUDE IN MAIN TEMPLATE.*/
//<script src="{{ 'bingapp.main.js' | asset_url }}"></script>  
//<script>bingapp.load('{{ 'bingapp.main.js' | asset_url }}');</script> 


//Module setup.
var bingapp = {
    client: {
        id: 0,
        name: "",
        key: "",
    },
    apiUrl: "https://bingapp.cl/API/",
    curSec: "",
    modules: [],
    front: {},
    back: {},
    initialized: false,
    debug: true,
    log: function (txt) {
        if (bingapp.debug) {
            console.log("-------- BINGAPP DEBUG --------");
            console.log(txt);
        }
    },
    rootUrl: "globo-rojo-cl.myshopify.com/Assets/",
    load: function (myUrl) {
        let v = myUrl.split("/");
        let r = "";
        for (let i = 0; i < v.length - 1; i++)
        {
            r += v[i] + "/";
        }

        bingapp.rootUrl = r;
        bingapp.load2();
    },
    load2: function () {
        if (!bingapp.initialized) {
            if (typeof (jQuery) != "function") {

                bingapp.getCss(bingapp.rootUrl + "bingapp.main.css");
                bingapp.getScript("https://code.jquery.com/jquery-3.4.1.min.js", function () { bingapp.load2(); }, function () { bingapp.error(1); });
                setTimeout(bingapp.load2, 2000);
            }
            else {
                bingapp.init();
            }
        }
    },
    init: function () {
        //Jquery loaded, then load modules..
        try{
            bingapp.curSec = document.location.pathname.split("/")[1];
        }
        catch(e)
        {
            bingapp.cursec = "";
        }
        bingapp.initialized = true;
        bingapp.getFirstParty();
        bingapp.getThirdParty();

        bingapp.getScript(bingapp.rootUrl + "bingapp.config.js", function () {
            for (let i = 0; i < bingapp.modules.length; i++) {
                bingapp.loadModule(bingapp.modules[i]);
            }
        }, null);
        //bingapp.log(bingapp.rootUrl);
    },
    loadModule: function(module){
        //bingapp.log("Attepting to load module: " + module[0])
        bingapp.getScript(bingapp.rootUrl + "bingapp." + module[0] + ".js", function () {
            let m = eval("bingapp." + module[0]);
            let b = true;
            if (bingapp.isset(m.sections))
            {
                if (m.sections.length>0)
                {
                    b = bingapp.inSection(m.sections);
                }
            }
            m.init(module[1]);
        }, function () {
            bingapp.error("Error loading module: " + module[0]);
        });
    },
    inSection: function(sections){
        //Check if an array of sections corresponds to current
        let curSec = bingapp.curSec;
        if (sections.filter(function(item){if (item==curSec) return true;}).length>0)
        {
            return true;
        }
        return false;
    },
    getFirstParty: function () {
        bingapp.getCss(bingapp.rootUrl + "bingapp.main.css");
        //bingapp.getCss(bingapp.rootUrl + "/tingle.min.css");
        
    },
    getThirdParty: function(){
        //bingapp.getCss(bingapp.rootUrl + "tingle.min.css");
        //bingapp.getScript(bingapp.rootUrl + "tingle.min.js",null,null,false);

        bingapp.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js", null, null, false);
        bingapp.getCss("https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css", null, null, false);
        
        //$("body").append('<div class="tingle-modal-box" style="display:none"><div class="tingle-modal-box__content"></div><div class="tingle-modal-box__footer"></div></div>');
    },
    error: function (errorCode) {
        console.error("*->BINGAPP ERROR: \r\n " + errorCode);
    },
    getScript: function (script, onLoad, onError,nocache) {
        if (!bingapp.isset(nocache)) nocache = true;
        let doIt = true;
        if (typeof (jQuery) == "function") {
            if ($("script[elScript='" + script + "']").length > 0) doIt = false;
        }

        if (doIt) {
            let s = document.createElement("script");
            if (nocache) s.src = script + "?no-cache=" + Date.now();
            else s.src = script;
          s.charset = "UTF-8";
            console.log(s.src);
            //s.onload = autoLiker.okCupidMessager.start;
            s.onload = function () {
                //bingapp.log("Script loaded:" + script);
                if (bingapp.isset(onLoad)) {
                    try {
                        onLoad();
                        //bingapp.log("Script initialized: " + script);
                    }
                    catch (ex) {
                        bingapp.error("Initializing module");
                        bingapp.error(ex);
                    }
                    
                }
            };
            try {
                $(s).attr("elScript", script);
            }
            catch (ex) {
                console.log(ex);
            }
            document.head.appendChild(s);
            
        }
        else {
            //bingapp.log("Script was already loaded: " + script);
            if (bingapp.isset(onLoad)) {
                try {
                    onLoad();
                    //bingapp.log("Script initialized: " + script);
                }
                catch (ex) {
                    bingapp.error("Initializing module");
                    bingapp.error(ex);
                }
                
            }
        }
    },
    getCss: function(css,onLoad,onError,cache)
    {
        if (!bingapp.isset(cache)) cache = true;
        let link = document.createElement("link");
        //link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        if (cache) link.href = css + "?no-cache=" + Date.now();
        else link.href = css;
        link.media = 'all';
        //s.onload = autoLiker.okCupidMessager.start;
        document.head.appendChild(link);
    },
    isset: function (variable_name) {
        try {
            if (typeof (variable_name) != 'undefined')
                if (variable_name != null)
                    return true;
        } catch (e) { }
        return false;
    },
    doTry: function(func,onDone,wait,times,i)
    {
        if (!bingapp.isset(i)) i = 0;
        let b = false;
        try {
            
            func();
            b= true;
        }
        catch(e)
        {
            //bingapp.log("trying again: " + e);
            if (i < times)
            {
                i++;
                setTimeout(function () {
                    bingapp.doTry(func,onDone, wait, times, i);
                }, wait);
            }
        }
        if (b) {
            if (bingapp.isset(onDone)) {
                onDone();
            }
        }
    },
    errIfNotSet: function (test) {
        if (!bingapp.isset(test))
        {
            let a = 1/0;
        }
    }

};

//bingapp.modules = new Array();







